import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { studentListDataProperties, enrolledAndWaitlistedStudentListDataProperties } from 'src/app/core/constants/configuration/student-constants.config';
import { DataProperties } from 'src/app/core/models/data-properties.model';
import { LoaderMessagingService } from 'src/app/core/services/messaging/loader-messaging.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { STUDENTS_PATH } from 'src/app/core/constants/routes.constant';
import { Router } from '@angular/router';

@Component({
	selector: 'enrolled-students-list',
	templateUrl: './enrolled-students-list.component.html',
	styleUrls: ['./enrolled-students-list.component.scss']
})
export class EnrolledStudentsListComponent implements OnInit, OnDestroy {

    @Input() items: any[];
    @Input() isLoadingStudents: boolean;

    unsubscribe: Subject<any> = new Subject();
    dataProperties: DataProperties[] = enrolledAndWaitlistedStudentListDataProperties;

    constructor(
        private loaderMessagingService: LoaderMessagingService,
        private router: Router,
    ) {
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    hasTooltipAndEllipses(property: string): boolean {
        return ['name', 'scope'].includes(property);
    }

    onLinkClick($event: any, id: string): void {
        this.router.navigate([STUDENTS_PATH, id]);
    }
}
